import React from 'react';
import { getPrefix } from '../../../util/utils';

const EspelhoStressHeader = ({ stress }) => (
  <>
    <strong className="mr-auto">Código: </strong>
    {stress?.CODSTRESS}&nbsp;&nbsp;&nbsp;
    <strong className="mr-auto">Nome do Paciente: </strong>
    {`${stress?.CODPAC} - ${stress?.NOMEPAC}`}
    <br></br>
    <strong className="mr-auto">Data de Nasc: </strong>
    {`${stress?.dataNasc}`}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <strong className="mr-auto">Sexo: </strong>
    {`${stress?.SEXOPAC}`}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <strong className="mr-auto">Idade: </strong>
    {`${stress?.idadePAC} anos`}
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <strong className="mr-auto">Peso: </strong>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <strong className="mr-auto">Alt: </strong>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <strong className="mr-auto">SC: </strong>
    <br></br>
    <strong className="mr-auto">Convênio: </strong>
    {stress?.SIGLACONV}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <strong className="mr-auto">Data do Stress: </strong>
    {stress?.dataStress}
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <strong className="mr-auto">Fone: </strong>
    {stress?.CELULARPAC}
    <br></br>
    <strong className="mr-auto">
      Médico que Realizou: {getPrefix(stress?.CODREALIZOU)}{' '}
    </strong>
    {`${stress?.Realizou}`}
    <br></br>
    <strong className="mr-auto">
      Médico que Solicitou: {getPrefix(stress?.CODSOLICITANTE)}{' '}
    </strong>
    {`${stress?.Solicitou}`}
    <hr></hr>
  </>
);

export default EspelhoStressHeader;
